export default {
  name: "",
  components: {}
};